module.exports = __webpack_public_path__ + "static/expand2-d6b299c81906cced8b8075104eadd724.png";